import * as VisitService from "../../../services/VisitService";
import useResources from "../../../hooks/UseResources";

export default function useLatestVisits() {
    return useResources(VisitService.getLatestVisits);
}
